

export function sortByName(array:any[], key:string){
console.log("Sorting by key: ", key);
console.log("Array before sorting: ", array);
    if (!array || !Array.isArray(array) || array.length === 0) {
    console.warn("Array is empty or not an array");
    }
    array.sort((a,b)=> a[key]!=="" && a[key] !== undefined && b[key]!==" " && b[key] !== undefined ? a[key].localeCompare(b[key].toLowerCase()):0);
    console.log("Array after sorting: ", array);
    return array;

}